module.exports = __webpack_public_path__ + "static/media/longText.99c0ea6a.png";